/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Box } from '@mui/material';

export type ReactionPreviewType = {
  text: string;
  name: string;
  isAgent: boolean;
};
type ReactionPreviewProps = {
  reactionPreview: ReactionPreviewType;
};

const ReactionPreview = ({ reactionPreview }: ReactionPreviewProps) => {
  return (
    <Box
      css={css`
        display: flex;
        align-items: center;
        gap: 4px;
        color: #616161;
        font-size: 14px;
        font-weight: 400;
      `}
    >
      {reactionPreview.isAgent ? <span>{reactionPreview.name}</span> : null}
      {reactionPreview.isAgent ? <span>reacted</span> : <span>Reacted</span>}
      <span>{reactionPreview.text}</span>
      <span>to&nbsp;</span>
    </Box>
  );
};

export default ReactionPreview;
